var _clipPath, _clipPath2, _clipPath3, _clipPath4, _clipPath5, _clipPath6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNodejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "27px",
    height: "27px",
    viewBox: "0 0 27 27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.527344 10 L 13.144531 10 L 13.144531 15.277344 L 8.527344 15.277344 Z M 8.527344 10 "
  }))), _clipPath2 || (_clipPath2 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.804688 10.253906 L 8.925781 11.339844 C 8.855469 11.382812 8.8125 11.453125 8.8125 11.535156 L 8.8125 13.707031 C 8.8125 13.785156 8.855469 13.863281 8.925781 13.898438 L 10.804688 14.984375 C 10.875 15.023438 10.960938 15.023438 11.03125 14.984375 L 12.910156 13.898438 C 12.980469 13.855469 13.023438 13.785156 13.023438 13.707031 L 13.023438 11.535156 C 13.023438 11.453125 12.980469 11.378906 12.910156 11.339844 L 11.03125 10.253906 C 10.992188 10.234375 10.957031 10.222656 10.917969 10.222656 C 10.882812 10.222656 10.84375 10.234375 10.804688 10.253906 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 0.3773,
    y1: -0.0470335,
    x2: 0.9962,
    y2: -0.0470335,
    gradientTransform: "matrix(-4.382748,8.940775,-8.940775,-4.382748,13.508705,6.276128)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    style: {
      stopColor: "rgb(33.333333%,57.647059%,30.980392%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    style: {
      stopColor: "rgb(35.294118%,67.843137%,27.058824%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(35.294118%,67.843137%,27.058824%)",
      stopOpacity: 1
    }
  })), _clipPath3 || (_clipPath3 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.527344 10 L 13 10 L 13 15.277344 L 8.527344 15.277344 Z M 8.527344 10 "
  }))), _clipPath4 || (_clipPath4 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.859375 13.839844 C 8.878906 13.863281 8.898438 13.882812 8.925781 13.898438 L 10.535156 14.828125 L 10.804688 14.984375 C 10.84375 15.007812 10.890625 15.015625 10.933594 15.011719 C 10.949219 15.011719 10.96875 15.007812 10.976562 15 L 12.960938 11.378906 C 12.945312 11.363281 12.929688 11.34375 12.90625 11.335938 L 11.675781 10.628906 L 11.027344 10.253906 C 11.011719 10.246094 10.988281 10.238281 10.96875 10.234375 Z M 8.859375 13.839844 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 0.050268,
    y1: 0.1331,
    x2: 0.6691,
    y2: 0.1331,
    gradientTransform: "matrix(7.981686,-5.897518,5.897518,7.981686,7.256612,13.681262)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "rgb(38.039216%,59.607843%,34.117647%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(46.27451%,67.45098%,39.215686%)",
      stopOpacity: 1
    }
  })), _clipPath5 || (_clipPath5 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.882812 10 L 13.144531 10 L 13.144531 15.277344 L 8.882812 15.277344 Z M 8.882812 10 "
  }))), _clipPath6 || (_clipPath6 = /*#__PURE__*/React.createElement("clipPath", {
    id: "clip6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.898438 10.222656 C 10.863281 10.226562 10.832031 10.234375 10.804688 10.25 L 8.929688 11.328125 L 10.949219 15.007812 C 10.976562 15 11.003906 14.996094 11.03125 14.980469 L 12.910156 13.894531 C 12.972656 13.863281 13.007812 13.800781 13.019531 13.738281 L 10.960938 10.226562 C 10.945312 10.222656 10.929688 10.222656 10.917969 10.222656 C 10.90625 10.222656 10.902344 10.222656 10.898438 10.222656 "
  }))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 0.1301,
    y1: 0.2836,
    x2: 0.7489,
    y2: 0.2836,
    gradientTransform: "matrix(6.601165,0,0,6.601165,8.075506,10.743997)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "rgb(41.960784%,74.901961%,27.843137%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    style: {
      stopColor: "rgb(41.960784%,74.901961%,27.843137%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    style: {
      stopColor: "rgb(47.45098%,70.588235%,38.039216%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    style: {
      stopColor: "rgb(45.882353%,67.45098%,39.215686%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "rgb(39.607843%,61.960784%,35.294118%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "rgb(24.313725%,52.54902%,23.921569%)",
      stopOpacity: 1
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.784314%,62.352941%,38.823529%)",
      fillOpacity: 1
    },
    d: "M 13.386719 19.535156 C 13.324219 19.535156 13.257812 19.519531 13.199219 19.488281 L 12.601562 19.136719 C 12.515625 19.089844 12.558594 19.074219 12.585938 19.0625 C 12.707031 19.019531 12.726562 19.011719 12.859375 18.9375 C 12.867188 18.933594 12.890625 18.933594 12.902344 18.941406 L 13.359375 19.214844 C 13.375 19.222656 13.398438 19.222656 13.414062 19.214844 L 15.195312 18.1875 C 15.210938 18.175781 15.222656 18.160156 15.222656 18.140625 L 15.222656 16.085938 C 15.222656 16.066406 15.210938 16.050781 15.195312 16.039062 L 13.417969 15.011719 C 13.402344 15 13.378906 15 13.367188 15.011719 L 11.589844 16.039062 C 11.574219 16.050781 11.5625 16.066406 11.5625 16.085938 L 11.5625 18.140625 C 11.5625 18.160156 11.574219 18.175781 11.589844 18.1875 L 12.074219 18.46875 C 12.339844 18.601562 12.5 18.445312 12.5 18.289062 L 12.5 16.253906 C 12.5 16.226562 12.523438 16.203125 12.554688 16.203125 L 12.78125 16.203125 C 12.808594 16.203125 12.828125 16.226562 12.828125 16.253906 L 12.828125 18.285156 C 12.828125 18.636719 12.636719 18.839844 12.300781 18.839844 C 12.199219 18.839844 12.117188 18.839844 11.890625 18.726562 L 11.425781 18.457031 C 11.3125 18.390625 11.238281 18.269531 11.238281 18.132812 L 11.238281 16.082031 C 11.238281 15.945312 11.308594 15.820312 11.425781 15.757812 L 13.207031 14.730469 C 13.324219 14.664062 13.472656 14.664062 13.582031 14.730469 L 15.363281 15.757812 C 15.476562 15.820312 15.550781 15.945312 15.550781 16.082031 L 15.550781 18.132812 C 15.550781 18.269531 15.480469 18.390625 15.363281 18.457031 L 13.582031 19.484375 C 13.515625 19.515625 13.453125 19.535156 13.386719 19.535156 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.784314%,62.352941%,38.823529%)",
      fillOpacity: 1
    },
    d: "M 13.9375 18.121094 C 13.160156 18.121094 12.996094 17.765625 12.996094 17.464844 C 12.996094 17.4375 13.019531 17.414062 13.050781 17.414062 L 13.285156 17.414062 C 13.3125 17.414062 13.332031 17.429688 13.332031 17.457031 C 13.367188 17.691406 13.472656 17.808594 13.941406 17.808594 C 14.316406 17.808594 14.476562 17.722656 14.476562 17.523438 C 14.476562 17.410156 14.433594 17.324219 13.851562 17.261719 C 13.367188 17.214844 13.0625 17.105469 13.0625 16.71875 C 13.0625 16.355469 13.367188 16.144531 13.871094 16.144531 C 14.445312 16.144531 14.726562 16.347656 14.757812 16.765625 C 14.757812 16.785156 14.753906 16.792969 14.742188 16.804688 C 14.730469 16.816406 14.71875 16.820312 14.703125 16.820312 L 14.472656 16.820312 C 14.449219 16.820312 14.429688 16.804688 14.421875 16.785156 C 14.367188 16.535156 14.234375 16.457031 13.867188 16.457031 C 13.457031 16.457031 13.410156 16.601562 13.410156 16.707031 C 13.410156 16.835938 13.460938 16.875 14.019531 16.949219 C 14.5625 17.019531 14.824219 17.125 14.824219 17.511719 C 14.824219 17.902344 14.5 18.121094 13.9375 18.121094 M 16.101562 15.945312 L 16.160156 15.945312 C 16.210938 15.945312 16.222656 15.914062 16.222656 15.890625 C 16.222656 15.839844 16.183594 15.839844 16.167969 15.839844 L 16.109375 15.839844 Z M 16.027344 15.773438 L 16.160156 15.773438 C 16.203125 15.773438 16.296875 15.773438 16.296875 15.875 C 16.296875 15.945312 16.253906 15.960938 16.226562 15.96875 C 16.28125 15.972656 16.28125 16.007812 16.292969 16.054688 C 16.296875 16.085938 16.304688 16.140625 16.3125 16.15625 L 16.234375 16.15625 C 16.234375 16.140625 16.214844 16.042969 16.214844 16.039062 C 16.210938 16.015625 16.203125 16.007812 16.179688 16.007812 L 16.113281 16.007812 L 16.113281 16.160156 L 16.039062 16.160156 L 16.039062 15.773438 Z M 15.871094 15.96875 C 15.871094 16.128906 16 16.253906 16.15625 16.253906 C 16.320312 16.253906 16.445312 16.125 16.445312 15.96875 C 16.445312 15.804688 16.3125 15.679688 16.15625 15.679688 C 16 15.679688 15.871094 15.804688 15.871094 15.96875 M 16.503906 15.96875 C 16.503906 16.15625 16.347656 16.3125 16.15625 16.3125 C 15.96875 16.3125 15.8125 16.160156 15.8125 15.96875 C 15.8125 15.773438 15.972656 15.621094 16.15625 15.621094 C 16.339844 15.628906 16.503906 15.773438 16.503906 15.96875 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.098039%,25.490196%,21.568627%)",
      fillOpacity: 1
    },
    d: "M 7.871094 11.496094 C 7.871094 11.414062 7.828125 11.339844 7.761719 11.296875 L 5.875 10.210938 C 5.84375 10.195312 5.804688 10.183594 5.773438 10.179688 L 5.75 10.179688 C 5.714844 10.179688 5.679688 10.191406 5.648438 10.210938 L 3.761719 11.296875 C 3.695312 11.339844 3.648438 11.414062 3.648438 11.496094 L 3.65625 14.421875 C 3.65625 14.46875 3.675781 14.503906 3.710938 14.519531 C 3.742188 14.542969 3.792969 14.542969 3.824219 14.519531 L 4.941406 13.878906 C 5.011719 13.835938 5.054688 13.757812 5.054688 13.675781 L 5.054688 12.3125 C 5.054688 12.230469 5.097656 12.15625 5.167969 12.113281 L 5.640625 11.835938 C 5.679688 11.816406 5.71875 11.804688 5.757812 11.804688 C 5.792969 11.804688 5.835938 11.816406 5.871094 11.835938 L 6.34375 12.113281 C 6.414062 12.15625 6.457031 12.226562 6.457031 12.3125 L 6.457031 13.675781 C 6.457031 13.757812 6.5 13.835938 6.574219 13.878906 L 7.695312 14.519531 C 7.734375 14.542969 7.777344 14.542969 7.808594 14.519531 C 7.839844 14.5 7.863281 14.460938 7.863281 14.421875 Z M 16.777344 13.019531 C 16.777344 13.039062 16.765625 13.058594 16.75 13.070312 L 16.101562 13.441406 C 16.085938 13.453125 16.066406 13.453125 16.042969 13.441406 L 15.394531 13.070312 C 15.378906 13.058594 15.367188 13.039062 15.367188 13.019531 L 15.367188 12.269531 C 15.367188 12.246094 15.378906 12.230469 15.394531 12.21875 L 16.042969 11.847656 C 16.058594 11.835938 16.082031 11.835938 16.101562 11.847656 L 16.75 12.21875 C 16.765625 12.230469 16.777344 12.246094 16.777344 12.269531 Z M 16.957031 7.480469 C 16.917969 7.457031 16.875 7.457031 16.84375 7.480469 C 16.808594 7.5 16.789062 7.539062 16.789062 7.574219 L 16.789062 10.476562 C 16.789062 10.503906 16.773438 10.53125 16.75 10.546875 C 16.722656 10.5625 16.699219 10.5625 16.667969 10.546875 L 16.195312 10.277344 C 16.125 10.234375 16.039062 10.234375 15.96875 10.277344 L 14.078125 11.367188 C 14.007812 11.410156 13.964844 11.480469 13.964844 11.5625 L 13.964844 13.742188 C 13.964844 13.824219 14.007812 13.898438 14.078125 13.941406 L 15.96875 15.035156 C 16.039062 15.078125 16.125 15.078125 16.195312 15.035156 L 18.085938 13.941406 C 18.15625 13.898438 18.199219 13.828125 18.199219 13.742188 L 18.199219 8.304688 C 18.199219 8.222656 18.15625 8.148438 18.078125 8.105469 Z M 23.242188 12.253906 C 23.3125 12.210938 23.355469 12.136719 23.355469 12.058594 L 23.355469 11.53125 C 23.355469 11.449219 23.3125 11.371094 23.242188 11.328125 L 21.367188 10.238281 C 21.296875 10.195312 21.210938 10.195312 21.140625 10.238281 L 19.25 11.328125 C 19.179688 11.371094 19.136719 11.441406 19.136719 11.53125 L 19.136719 13.707031 C 19.136719 13.785156 19.179688 13.863281 19.25 13.90625 L 21.125 14.972656 C 21.195312 15.011719 21.277344 15.011719 21.347656 14.972656 L 22.480469 14.34375 C 22.515625 14.320312 22.539062 14.28125 22.539062 14.246094 C 22.539062 14.203125 22.515625 14.164062 22.480469 14.148438 L 20.578125 13.058594 C 20.542969 13.035156 20.519531 12.996094 20.519531 12.960938 L 20.519531 12.273438 C 20.519531 12.230469 20.542969 12.191406 20.578125 12.175781 L 21.167969 11.835938 C 21.207031 11.816406 21.25 11.816406 21.28125 11.835938 L 21.871094 12.175781 C 21.910156 12.199219 21.929688 12.234375 21.929688 12.273438 L 21.929688 12.8125 C 21.929688 12.859375 21.953125 12.894531 21.988281 12.910156 C 22.027344 12.933594 22.070312 12.933594 22.101562 12.910156 Z M 23.242188 12.253906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(40.784314%,62.352941%,38.823529%)",
      fillOpacity: 1
    },
    d: "M 21.222656 12.148438 C 21.234375 12.144531 21.253906 12.144531 21.265625 12.148438 L 21.625 12.359375 C 21.644531 12.367188 21.648438 12.382812 21.648438 12.398438 L 21.648438 12.8125 C 21.648438 12.828125 21.636719 12.847656 21.625 12.851562 L 21.265625 13.0625 C 21.25 13.070312 21.234375 13.070312 21.222656 13.0625 L 20.859375 12.851562 C 20.84375 12.847656 20.839844 12.828125 20.839844 12.8125 L 20.839844 12.398438 C 20.839844 12.382812 20.84375 12.367188 20.859375 12.359375 Z M 21.222656 12.148438 "
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear0)"
    },
    d: "M 14.917969 11.152344 L 9.628906 8.558594 L 6.917969 14.09375 L 12.210938 16.6875 Z M 14.917969 11.152344 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip4)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear1)"
    },
    d: "M 6.578125 11.917969 L 10.308594 16.972656 L 15.25 13.328125 L 11.511719 8.265625 Z M 6.578125 11.917969 "
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip5)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip6)",
    clipRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "url(#linear2)"
    },
    d: "M 8.9375 10.222656 L 13.019531 10.222656 L 13.019531 15.007812 L 8.9375 15.007812 Z M 8.9375 10.222656 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNodejs);
export default __webpack_public_path__ + "static/media/nodejs.1304d4e8bf6f7c470c67e653c737761d.svg";
export { ForwardRef as ReactComponent };